import { defineComponent as r, computed as l, openBlock as a, createElementBlock as h, createElementVNode as t, toDisplayString as v, createCommentVNode as d, normalizeStyle as n, createStaticVNode as f } from "vue";
const m = ["viewBox"], p = /* @__PURE__ */ t("mask", { id: "bd178c8c-cb15-4a3c-86bf-c915b22b5e75" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), _ = { mask: "url(#bd178c8c-cb15-4a3c-86bf-c915b22b5e75)" }, u = { key: 0 }, k = /* @__PURE__ */ f('<path fill="#0052b4" d="M256 0h256v512H0V256Z"></path><path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"></path><path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"></path><path fill="#eee" d="m313 267 7 15 15-4-7 15 13 10-16 3v16l-13-10-12 10v-16l-16-3 13-10-7-15 16 4zm66-61 7 15 15-4-7 15 13 10-16 4v16l-13-10-12 10v-16l-16-4 13-10-7-15 16 4zm1 146 40-29h-50l40 29-15-48Zm-1 29 5 15 14-7-7 15 15 5-15 5 7 15-14-7-5 15-6-15-14 7 7-15-15-5 15-5-7-15 14 7zm57-114-8 14h-16l8 14-8 14h16l8 13 8-13h16l-8-14 8-14h-16z"></path><path fill="#ffda44" d="M370 93v8h-8v17h8v15a25 25 0 0 0-34 37v15h85v-15a25 25 0 0 0-34-37v-15h8v-17h-8v-8z"></path>', 5), g = { fill: "none" }, b = ["r"], w = /* @__PURE__ */ r({
  __name: "au-vic",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(s) {
    const e = s, o = l(() => 512 + 2 * e.strokeWidth), c = l(() => -e.strokeWidth), i = l(() => 256 + e.strokeWidth / 2);
    return (V, x) => (a(), h("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${c.value} ${c.value} ${o.value} ${o.value}`
    }, [
      p,
      t("g", _, [
        e.flagName ? (a(), h("title", u, v(e.flagName), 1)) : d("", !0),
        k
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: i.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, m));
  }
});
export {
  w as default
};
//# sourceMappingURL=au-vic-070e3474.js.map
